import { useMutation } from "react-query";

import employeesService from "api/employeesService";

const useDeleteEmployeeMutation = () => {
  return useMutation(async (id: number) => {
    try {
      const res = await employeesService.deleteEmployee(id)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useDeleteEmployeeMutation